// extracted by mini-css-extract-plugin
export default {"root":"LineChartSkeleton_root__jm3Ol"};